import { graphql, compose } from 'react-apollo'
import Knowledge from './components/index'
import { getBlogs, getArticleHelpState } from '../knowledge/actions/queries'
import { insertView, updateArticleHelpState } from '../knowledge/actions/mutation'
import get from 'lodash/get'

import { getPatientIdFromUrl } from '../../utils'

export default compose(
  graphql(getBlogs, {
    name: 'blogs',
    options: props => ({
      variables: {
        // limit: 3,
        blogId: get(props, 'match.params.knowledgeId'),
        systemType: get(props, 'match.params.systemType', 'BG'),
      },
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(insertView, { name: 'insertView' }),
  graphql(updateArticleHelpState, { name: 'updateArticleHelpState' }),
  graphql(getArticleHelpState, {
    name: 'articleHelpState',
    options: props => {
      const patientId = getPatientIdFromUrl(props)
      return {
        variables: {
          articleId: get(props, 'match.params.knowledgeId'),
          patientId,
        },
        fetchPolicy: 'network-only',
      }
    }
  }),
)(Knowledge)



// WEBPACK FOOTER //
// ./src/modules/knowledgeShare/index.js